import { englishMessages } from 'admin-on-rest';

import customBahasaMessages from './id';
import customEnglishMessages from './en';

export default {
  id: { ...englishMessages, ...customBahasaMessages },
  en: { ...englishMessages, ...customEnglishMessages },
};



// WEBPACK FOOTER //
// ./src/i18n/index.js